import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingCreditRebillErrorSlideout extends Layout {
    tableErrorMessages: Table;
}
